export enum ReimbursableTypeEnum {
  TimeSettingsCustomTimeRangeCategory = 'TimeSettings::CustomTimeRangeCategory',
  FinanceCustomCategory = 'Finance::CustomCategory',
}

export * from './payrollRunStatus'
export * from './paymentRequestStatus'
export * from './currency'
export const COMPENSATIONS_IMPORT_THRESHOLD_MAPPING = 0.5
